"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResetViewModel = void 0;
const react_1 = require("react");
const useResetViewModel = (controller) => {
    (0, react_1.useEffect)(() => {
        return () => {
            if ('resetViewModel' in controller)
                controller.resetViewModel();
        };
    }, []);
};
exports.useResetViewModel = useResetViewModel;
//# sourceMappingURL=useResetViewModel.js.map